import { PopupDeNotificacoes } from '../PopupDeNotificacoes'

import { useBloc } from './bloc'
import classes from './styles.module.scss'

const ID_DO_POPUP = 'popup-de-notificacoes'

export function SinoDeNotificacoes(): JSX.Element {
  const {
    referenciaDoContainer,
    popupAberto,
    existemNaoVisualizadas,
    rotuloDoBotao,
    alternarPopup,
    fecharPopup,
    aoPassarMouse,
    aoTirarMouse,
  } = useBloc()

  return (
    <li
      className={classes.container}
      ref={referenciaDoContainer}
      onMouseEnter={aoPassarMouse}
      onMouseLeave={aoTirarMouse}
    >
      <button
        type="button"
        className="cabecalho-sistema__item-de-menu"
        onClick={alternarPopup}
        aria-label={rotuloDoBotao}
        aria-haspopup="dialog"
        aria-expanded={popupAberto}
        aria-controls={ID_DO_POPUP}
      >
        <span className={classes.icone}>
          <i className="fa-regular fa-bell" aria-hidden="true" />
          {existemNaoVisualizadas && (
            <span className={classes.indicador} aria-hidden="true" />
          )}
        </span>
      </button>

      {popupAberto && (
        <PopupDeNotificacoes id={ID_DO_POPUP} aoFechar={fecharPopup} />
      )}
    </li>
  )
}
